var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitTimeHeaderInnerBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 270,
    viewBox: "0 0 255 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.705 151.503C235.353 228.329 186.063 282.849 111.234 267.088C36.4044 251.326 -11.8148 176.244 3.53718 99.4183C18.8892 22.5928 88.9967 -11.8438 163.826 3.9416C238.679 19.7031 266.057 74.6775 250.705 151.503Z",
    fill: "#79E2CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitTimeHeaderInnerBlob);
export default __webpack_public_path__ + "static/media/wait-time-header-inner-blob.327f8d1eccb0d0d9d7c042d0e6e88b73.svg";
export { ForwardRef as ReactComponent };